import type { ReactNode } from "react";
import { twJoin } from "tailwind-merge";

import svgSrc from "./assets/no-data.svg";
import { Button } from "./Button";

type NoDataStateProps = {
  title: string;
  description: string;
  orientation?: "vertical" | "horizontal";
  action?: {
    label: string;
    onClick: () => void;
  };
};

export function NoDataState({ title, description, orientation = "vertical", action }: NoDataStateProps): ReactNode {
  const horizontal = orientation === "horizontal";

  return (
    <div
      className={twJoin(
        "my-no-data place-self-center",
        horizontal ? "w-full px-no-data-inline" : "w-no-data-vertical max-w-no-data-state",
      )}
    >
      <div className="@container">
        <div className={twJoin("flex items-center gap-no-data-gap", horizontal ? "flex-col @sm:flex-row" : "flex-col")}>
          <img className={horizontal ? "w-no-data-illustration" : "max-w-full"} src={svgSrc} alt="" />
          <div className="flex flex-col gap-xs text-center">
            <h4 className="text-caption-emphasis">{title}</h4>
            <p className="text-caption text-text-secondary">{description}</p>
          </div>
          {action && <Button onClick={action.onClick}>{action.label}</Button>}
        </div>
      </div>
    </div>
  );
}
